import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./viewInventory.css";
import Inventorys from "../../api/Inventory";

const Inventory = props => (
    <tr>
        <td>{props.inventory.date}</td>
        <td>{props.inventory.mname}</td>
        <td>{props.inventory.quantity}</td>
        <td>{props.inventory.unit}</td>
        <td>{props.inventory.rate}</td>
        <td>{props.inventory.total}</td>
        <td>
            <Link to={"/inventory/edit/" + props.inventory._id}><i className='bx bx-edit-alt'></i></Link> | <span onClick={() => { props.deleteInventory(props.inventory._id) }} ><i className='bx bx-trash'></i></span>
        </td>
    </tr>
)

class viewInventory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inventorys: []
        }
        this.deleteInventory = this.deleteInventory.bind(this);
    }

    componentDidMount() {
        Inventorys.get('/get-inventorys')
            .then(res => {
                this.setState({ inventorys: res.data })
            })
            .catch(error => console.log(error));
    }

    deleteInventory(id) {
        Inventorys.delete('/delete-inventory/' + id)
            .then(res => console.log(res.data));

        this.setState({ inventorys: this.state.inventorys.filter(el => el._id !== id) })
    }

    inventorysList() {
        return this.state.inventorys.map(currentinventory => {
            return <Inventory inventory={currentinventory} deleteInventory={this.deleteInventory} key={currentinventory._id} />
        })
    }

    render() {
        return (
            <div className='FideologyActivities'>
                <h3 className='fidoh3'>View Inventory</h3>
                <div className="fideo">

                    <table>
                        <thead className="thead-light">
                            <tr>
                                <th>Date</th>
                                <th>Product Name</th>
                                <th>Quantity</th>
                                <th>Unit</th>
                                <th>Rate</th>
                                <th>Total Amt.</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.inventorysList()}
                        </tbody>
                    </table>
                    <Link to='/add-inventory'><div className='add'>Add</div></Link>
                </div>
            </div>
        );
    }
}

export default viewInventory;